import { ApiStaticData } from "@libs/api/types";
import { api } from "../axios";

export type getFaqResponse = ApiStaticData<'faq', 'get'>

export const getFaqs = async (): Promise<getFaqResponse> => {
  const { data } = await api.get("/faq");

  return data;
}